module.exports = __webpack_public_path__ + "band_0.9591c410.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/band_0.png
// module id = aEPF
// module chunks = 0